<div class="countdown-checkout-timer">
  <div *ngIf="seconds">
    <strong>{{minutes}}</strong>:<strong>{{seconds}}</strong>
  </div>
</div>
